import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from './AdminAuthContext';
import s from './AdminAuth.module.css';

export default function AdminAuth() {
  const { login }   = useAdminAuth();
  const navigate    = useNavigate();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div className={s.page}>
      <div className={s.left}>
        <div className={s.brand}>
          <span className={s.brandV}>V</span>
          <span className={s.brandName}>endly</span>
        </div>
        <h1 className={s.headline}>Admin<br />Control<br />Centre</h1>
        <p className={s.tagline}>Manage orders, products, and sellers.</p>
        <div className={s.grid}>
          {[...Array(9)].map((_, i) => <span key={i} className={`${s.dot} ${i < 3 ? s.dotBright : ''}`} />)}
        </div>
      </div>

      <div className={s.right}>
        <form className={s.form} onSubmit={handleSubmit}>
          <h2 className={s.formTitle}>Sign in</h2>
          <p className={s.formSub}>Admin accounts only</p>

          {error && <div className={s.error}>{error}</div>}

          <div className={s.field}>
            <label className={s.label}>Email</label>
            <input className={s.input} type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@vendly.com" required autoFocus />
          </div>

          <div className={s.field}>
            <label className={s.label}>Password</label>
            <input className={s.input} type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
          </div>

          <button className={s.btn} type="submit" disabled={loading}>
            {loading ? <span className={s.spinner} /> : 'Sign in →'}
          </button>
        </form>
      </div>
    </div>
  );
}
